import React, { ReactNode, useState } from 'react';
import { TabPanel, ComingSoon } from './InstallSDK.styles';
import { HudIcon, IconType } from '@hud/web-components/Icons/HudIcons';
import {
  NotificationType,
  showNotification,
} from '../../../../components/ToastNotification/ToastNotification';
import { useAuth } from '../../../../hooks/useAuth';
import { addToWaitlist } from '../../../../services/waitlist';
import useAnalytics from '../../../../hooks/useAnalytics';
import type { Events } from '../../../../analytics';

type LanguageKey = 'python' | 'java' | 'dotnet';

export default function WaitingListTab({
  languageKey,
  languageName,
  content,
  waitlistText,
}: {
  languageKey: LanguageKey;
  languageName: string;
  content?: ReactNode;
  waitlistText?: string;
}) {
  const analytics = useAnalytics();
  const { user, token } = useAuth();

  const [joinedWaitlist, setJoinedWaitlist] = useState(false);

  async function onClickWaitlist(): Promise<void> {
    if (!user || !token) {
      console.error('User or token not available for waitlist');
      return;
    }
    const analyticsEvent = `registered_to_${languageKey}_waiting_list` as keyof Events;
    analytics.capture(analyticsEvent);


    // optimistically set the state to prevent multiple clicks
    setJoinedWaitlist(true);

    const success = await addToWaitlist({
      language: languageKey,
      user,
      token,
    });

    if (success) {
      showNotification({
        type: NotificationType.SUCCESS,
        message: "We got your request. We'll let you know once you're in",
        width: '455px',
      });
    } else {
      setJoinedWaitlist(false);
      showNotification({
        type: NotificationType.ERROR,
        message: 'Failed to add to waitlist',
        width: 'fit-content',
      });
    }
  }

  const languageIcon = `languages.${languageKey}` as IconType;

  return (
    <TabPanel value={languageKey}>
      <ComingSoon>
        <HudIcon icon={languageIcon} size="46px" />
        {content ?? (
          <p>{languageName} support is in the works and expected by end of 2025.</p>
        )}
        <button disabled={joinedWaitlist} onClick={onClickWaitlist}>
          {waitlistText ?? `Join the Waitlist`}
        </button>
      </ComingSoon>
    </TabPanel>
  );
}
